import { defineStore } from "pinia";
import usePermissions from "@/Services/PermissionsServices";
import useRoles from "@/Services/RolesServices";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        user: null,
        allPermissions: {}, // Contiendra le JSON brut du back
        allRoles: [],
        isLoaded: false,
        authPromise: null,
    }),

    actions: {
        setUser(userData) {
            this.user = userData;
        },

        async fetchAuthMetadata() {
            if (this.isLoaded) return;
            if (this.authPromise) return this.authPromise;

            const { getPermissions } = usePermissions();
            const { getRoles } = useRoles();

            this.authPromise = (async () => {
                try {
                    const [permsData, rolesData] = await Promise.all([
                        getPermissions(),
                        getRoles()
                    ]);

                    this.allPermissions = permsData?.data || permsData || {};
                    this.allRoles = rolesData?.data || rolesData || [];
                    this.isLoaded = true;
                } catch (error) {
                    console.error("Erreur métadonnées auth:", error);
                    this.isLoaded = false;
                } finally {
                    this.authPromise = null;
                }
            })();

            return this.authPromise;
        }
    }
});
